import { AgencyTypeId } from '@app/models/agency-type-id';
import { gql } from 'apollo-angular';

export interface DefaultComparisonOption {
  source?: AgencyTypeId;
  target?: AgencyTypeId;
}

export const defaultComparisonOption = gql`
  fragment defaultComparisonOption on DefaultComparisonOption {
    source {
      id
      description
    }
    target {
      id
      description
    }
  }
`;
